import { render } from "./TradicionalCard.vue?vue&type=template&id=fb61dba4&scoped=true"
import script from "./TradicionalCard.vue?vue&type=script&lang=js"
export * from "./TradicionalCard.vue?vue&type=script&lang=js"

import "./TradicionalCard.vue?vue&type=style&index=0&id=fb61dba4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb61dba4"]])

export default __exports__